module.exports = "https://r.zoocdn.com/_next/static/images/arrow-purple-small-646d0348a9ca965add33e4d34c5fcd11.svg";